{
  "carrierLabel": "Empresa transportista",
  "searchPlaceholder": "Buscar por nombre",
  "selectAsCarrier": "Seleccionar \"{name}\" como transportista",
  "typeToSearch": "Escribe para buscar una empresa"
}
